import { UpaService, UpaTarget } from '../../../services/upa.service';
import { Component, Input, OnInit, OnChanges, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { Currency } from 'projects/common/model/landingModel';
import { OfferCardData, OfferCardDataPrice, OfferViewType, OfferCardType } from '../offer-card-data.model';
import { SelectableDatesService } from '../dates-popup/selectable-dates.service';
import { GtmService } from '../../../services/gtm.service';
import { LoyaltyMode } from '@shopping-angular-components/loyalty';
import { MediaPictureService } from '../../../services/media-picture.service';
import { ReplaceParamsPipe } from "../../../pipes/replace-params.pipe";
import { HotelsBoxService } from 'projects/common/services/hotelsBox.service';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { MetadataService } from 'projects/common/services/metadata.service';
import { FlightsService } from 'projects/common/services/flights.service';
import { TripProductType } from '../../wizumen/wizumen-models';
import { addRefererParam } from 'projects/common/components/offers/url-offer.utils';

declare var window: any;

@Component({
  selector: 'offer-card',
  template: `
    <div class="offer-card-container {{offerCardType}} {{data.offer_type === 'DUALTRIP' ? 'DUALTRIP' : ''}} offer-type-{{data.offer_type}}"
         [ngClass]="{'fixed-width': isFixedWidth}">
      <div target="_blank" class="offer-card-wrapper offer-card-clickeable" title="{{data.link.title}}" (click)="onOfferClicked($event)">

      <!-- TODO cambiar WOW por el offerCardType real" -->
        <div class="offer-card eva-3-offer-card eva-3-card -eva-3-shadow-line -eva-3-shadow-2-hover"
             [ngClass]="{'PROMOTED': data.promoted, 'without-ribbon': data.offer_type === 'ACTIVITY_MODALITIES' && !data.ribbon_top_card}">
          <offer-ribbon *ngIf="data.ribbon_top_card" [data]="data"></offer-ribbon>

          <ng-content select="[offer-image]"></ng-content>
          <ng-content select="[driver]"></ng-content>

          <div class="offer-card-info">
            <div class="offer-card-content">
              <ng-content select="[offer-content]"></ng-content>
            </div>

            <ng-content select="[custom-pricebox]" *ngIf="customPricebox; else pricebox"></ng-content>
            <ng-template #pricebox>
              <offer-card-pricebox *ngIf="!price?.prepaid_price_in_points && !price_child"
                [data]="data" [currency]="currency" [loyaltyMode]="loyaltyMode"
                [flow]="flow" [locale]="locale" [offerCardType]="offerCardType"
                (shoppingCartClicked)="onShoppingCartClicked($event)">
              </offer-card-pricebox>
              <pricebox-with-points *ngIf="price?.prepaid_price_in_points && !price_child" [price]="price" [currency]="currency" [locale]="locale"></pricebox-with-points>

              <pricebox-with-child *ngIf="price_child" [data]="data" [currency]="currency" [locale]="locale"></pricebox-with-child>
            </ng-template>

            <div *ngIf="data.offer_type === 'ACTIVITY_MODALITIES' && data.see_more_offers_link?.title && data.see_more_offers_link?.url" class="-eva-3-p-md">
              <button class="eva-3-btn -md -primary -eva-3-fwidth" name="">
                <em class="btn-text">{{data.see_more_offers_link.title}}</em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./offer-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferCardComponent implements OnInit, OnChanges {
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId?: string;
  @Input() positionIndex: number;
  @Input() offerViewType: OfferViewType;
  @Input() offerCardType: OfferCardType;

  @Input() data: OfferCardData;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() loyaltyMode: LoyaltyMode | null;
  @Input() flow: string;
  @Input() product: string;
  @Input() sboxAutocomplete?: boolean;
  @Input() isFixedWidth: boolean;
  @Input() customPricebox = false;
  @Input() moduleReferer?: string;

  @Output() offerClicked = new EventEmitter();

  price: OfferCardDataPrice;
  price_child?: OfferCardDataPrice;
  paymentsMediaKey?: string;
  href: string | null;
  isIframeDistribution: boolean;
  isHotelVrOrPromotion: boolean;

  constructor(private upaService: UpaService,
    private gtmService: GtmService,
    private selectableDatesService: SelectableDatesService,
    private replaceParamsPipe: ReplaceParamsPipe,
    private hotelsBoxService: HotelsBoxService,
    public mediaPictureService: MediaPictureService,
    private landingModelService: LandingModelService,
    private metadataService: MetadataService,
    private flightsService: FlightsService) {

    this.isIframeDistribution = this.landingModelService.getLandingModel().distributionId == 'dynamicIframe';
  }

  ngOnInit(): void {
    this.initPrice();
    this.paymentsMediaKey = this.mediaPictureService.getMediaUrl(this.data.payments_media_key);
    this.href = this.getHref();
    this.isHotelVrOrPromotion = ['hotels', 'vacation_rentals', 'promotions'].includes(this.data.product);
  }

  ngOnChanges(): void {
    this.initPrice();
    this.href = this.getHref();
  }

  onOfferClicked(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.offerClicked.emit();

    if (window.hotelsBox && this.sboxAutocomplete) {
      this.handleHotelClickedWithNoDates();
    } else if (this.data.offer_alternatives?.length > 0) {
      this.handleOfferAlternativesClicked();
    } else if (this.data.link?.url && this.href !== null) {
      this.track(this.href, UpaTarget.OFFER);
      const pageLoad = !this.metadataService.isXDespShowInfoEnabled() || confirm("¿Ir al enlace?\n" + this.href);
      const isXSell = this.data.link.type?.toString()?.startsWith("XSELL");
      if (pageLoad) window.open(this.href, this.isIframeDistribution || isXSell ? '_blank' : '_self');
    }
  }

  onShoppingCartClicked(url: string): void {
    if (this.data.shopping_cart_link?.type === TripProductType.FLIGHT) {
      this.track(url, UpaTarget.BUTTON, `${this.data.product}_carrito`);
      this.flightsService.showDistributionPassengersModalForOffer(this.moduleId, this.moduleIndex, this.data, true);
      return;
    }
    const resolvedUrl = this.replaceParamsPipe.transform(url, { currency: this.currency?.code, price: this.price?.total_amount_not_formatted });
    this.track(resolvedUrl, UpaTarget.BUTTON, `${this.data.product}_carrito`);
    window.open(resolvedUrl, '_blank');
  }

  track(href: string, target: UpaTarget, cartLabel?: string): void {
    this.gtmService.trackEventIfApplicable('user-action', 'offer-row-' + this.moduleIndex + 'position-' + this.positionIndex, 'Click', this.data.product);

    const destinationGid = this.data?.offer_tracking_data?.destination_gid ?? null;
    const recommendationId = this.data?.recommendation_id ?? this.data.product;
    const baseLabel = destinationGid ? `${recommendationId}|${destinationGid}` : recommendationId;
    const label = cartLabel ? `${baseLabel}|${cartLabel}` : baseLabel;

    this.upaService.trackClickTopic({
      label: label,
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      uniqueId: this.uniqueId,
      positionIndex: this.positionIndex,
      target: target,
      href: href,
      flags: this.data.flags,
      data: this.resolveTrackingData()
    });
  }

  getRibbon(): string {
    return this.price.promo.ribbon || `- ${this.price.promo.discount}%`;
  }

  private initPrice(): void {
    if (this.data?.offer_alternatives?.length > 0) {
      this.price = this.data.offer_alternatives[0].price[this.currency.code];
    } else if (this.data.price) {
      this.price = this.data.price[this.currency.code];
    }

    if (this.data.price_child && this.data.price_child[this.currency.code]) {
      this.price_child = this.data.price_child[this.currency.code];
    }
  }

  private getHref(): string | null {
    if ((this.data.offer_alternatives?.length || 0) > 0) {
      return null;
    }
    const url = this.data.force_domain ? `//${this.data.force_domain}${this.data.link.url}` : this.data.link.url;
    return this.replaceParamsPipe.transform(
      addRefererParam(url, this.moduleReferer, this.landingModelService.getLandingModel().refererName),
      { currency: this.currency?.code, price: this.price?.total_amount_not_formatted }
    );
  }

  private resolveTrackingData() {
    return {
      recommendation_id: this.data.recommendation_id,
      product: this.data.product,
      recommendation_position: this.data.recommendation_position?.toString()
    }
  }

  private handleHotelClickedWithNoDates() {
    this.hotelsBoxService.updateHotelsData(this.data);
    if (this.href !== null) this.track(this.href, UpaTarget.OFFER_COMPLETE_SBOX);
  }

  private handleOfferAlternativesClicked() {
    this.gtmService.trackEventIfApplicable('user-action', 'offer-modal-alternative-' + this.moduleIndex, 'Click', this.data.product);
    this.data.offer_alternatives.forEach(offer => {
      if (this.data.force_domain) {
        offer.link.url = `//${this.data.force_domain}${offer.link.url}`;
      }
    });
    this.selectableDatesService.openModal(this.currency.code, this.data, this.moduleId, this.moduleIndex, this.uniqueId);
  }
}
